module.exports = __webpack_public_path__ + "img/sec2_17.8117a9fd.png";